import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getUser,
  UserAddress,
  UserPersonalDetails,
  userResetPassword,
} from "./../../api";
import React, { useContext, createContext, useState } from "react";
import { getSession } from "./../../axios.config";

const accountSettings = createContext(undefined);

export const useSettings = () => useContext(accountSettings);

function useProvideAccountSettings() {
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState("basic-details");
  const user = JSON.parse(getSession("userId"));
  const [showOTP, setShowOTP] = useState(false);
  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordForm, setPasswordForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const useAccountData = (userId) => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["accountData", { userId }],
      enabled: !!userId,
      queryFn: getUser,
    });
    return { isLoading, isError, data, error };
  };

  const { mutate: personalDetails } = useMutation({
    mutationFn: UserPersonalDetails,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["PersonalData"] });
    },
  });

  const { mutate: AddressDetails } = useMutation({
    mutationFn: UserAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["addressData"] });
    },
  });

  const updatePersonalDetails = (data) => {
    personalDetails(data);
  };

  const {
    mutate: forgotPasswordDetails,
    isLoading: forgotPasswordResetIsLoading,
  } = useMutation({
    mutationFn: userResetPassword,
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: ["accountData"] });
      // setInviteAdminDrawer(false);
    },
    onError: (data) => {
      setErrors((prev) => ({
        ...prev,
        oldPassword: data?.message,
      }));
    },
  });

  const forgotPassword = (data) => {
    const updatedData = {
      newPassword: data?.newPassword,
      oldPassword: data?.oldPassword,
    };
    forgotPasswordDetails(updatedData);
  };

  const { mutate: otpVerification } = useMutation({
    mutationFn: userResetPassword,
    onSuccess: () => {
      setActiveTab("basic-details");
    },
    onError: (data) => {},
  });

  const OtpConfirmation = (data) => {
    const updatedData = {
      userId: user?.userId,
      otp: data?.otp,
      type: data?.type,
      newPassword: passwordForm?.newPassword,
      oldPassword: passwordForm?.oldPassword,
    };
    otpVerification(updatedData);
  };

  return {
    useAccountData,
    updatePersonalDetails,
    AddressDetails,
    forgotPassword,
    OtpConfirmation,
    showOTP,
    setShowOTP,
    errors,
    setErrors,
    passwordForm,
    setPasswordForm,
    activeTab,
    setActiveTab,
    forgotPasswordResetIsLoading,
  };
}

export function ProvideAccountSettings({ children }) {
  const overview = useProvideAccountSettings();
  return (
    <accountSettings.Provider value={overview}>
      {children}
    </accountSettings.Provider>
  );
}
